/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { MockLendingConnector } from "../MockLendingConnector";

export class MockLendingConnector__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _save: string,
    _mUSD: string,
    overrides?: Overrides
  ): Promise<MockLendingConnector> {
    return super.deploy(
      _save,
      _mUSD,
      overrides || {}
    ) as Promise<MockLendingConnector>;
  }
  getDeployTransaction(
    _save: string,
    _mUSD: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_save, _mUSD, overrides || {});
  }
  attach(address: string): MockLendingConnector {
    return super.attach(address) as MockLendingConnector;
  }
  connect(signer: Signer): MockLendingConnector__factory {
    return super.connect(signer) as MockLendingConnector__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockLendingConnector {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as MockLendingConnector;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_save",
        type: "address",
      },
      {
        internalType: "address",
        name: "_mUSD",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "checkBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "poke",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";
